import { QuestionGroupType } from '@exam-management/graphql';
import { LocationFields, LocationSectionWrapper } from '@exam-management/qcontent-management';
import {
  Flex,
  InfoOutlinedIcon,
  ReadonlyField,
  Text,
  Tooltip,
  PaperSection,
} from '@shared/components';
import { useMemo } from 'react';

import { useQuestionReviewTaskQuestionDetails } from '../../providers';

export default function QuestionLocationView() {
  const { question, qBankStructureLevels, qBankStructureLevelItems } =
    useQuestionReviewTaskQuestionDetails();
  const isLOQ = question.questionGroup?.type === QuestionGroupType.LotOfQuestion;

  const qBankStructureLevelWithoutFirstLevel = useMemo(
    () => qBankStructureLevels.filter((qBankStructureLevel) => qBankStructureLevel.level !== 1),
    [qBankStructureLevels],
  );

  const levelItems = useMemo(
    () =>
      qBankStructureLevelItems.filter((qbsLevelItem) =>
        question.questionStructures?.some(
          (questionStructure) => qbsLevelItem.id === questionStructure.refLevelItemId,
        ),
      ),
    [qBankStructureLevelItems, question.questionStructures],
  );

  return (
    <PaperSection title='Location' sx={{ flexBasis: '360px', alignSelf: 'baseline' }}>
      <LocationSectionWrapper>
        <LocationFields
          qbsLevels={qBankStructureLevelWithoutFirstLevel}
          qbsLevelItems={levelItems}
        />
        {isLOQ ? (
          <Flex sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(1) })}>
            <Flex sx={(theme) => ({ gap: theme.spacing(1) })}>
              <Text variant='body2Semibold'>LOQ</Text>
              <Tooltip title='ชุดของข้อสอบที่มีความคล้ายคลึงกันมาก'>
                <InfoOutlinedIcon
                  sx={{
                    fontSize: '20px',
                    color: (theme) => theme.palette.text.secondary,
                  }}
                />
              </Tooltip>
            </Flex>
            <ReadonlyField content={question.questionGroup?.name ?? ''} />
          </Flex>
        ) : null}
      </LocationSectionWrapper>
    </PaperSection>
  );
}
